module.exports = __webpack_public_path__ + "img/atlantis.431f7944.svg";